export enum SendEmailMethodEnum {
  MANUALLY = 'manually',
  AUTOMATICALLY = 'automatically',
}
